<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
<div class="container blog-item custom">
  <h1>
    თიბისი ლიზინგის სამუშაო გარემო<br />
    <span style="font-family: TBCX-Regular;">Vol.1</span>
  </h1>
  <h6>ნოემბერი 2023</h6>
  <br />

  <p>
    “ChatGPT, მაჩვენე როგორი უნდა იყოს სამუშაო კვირა კომპანიაში, რომელშიც თანამშრომლებზე ზრუნვაა პრიორიტეტული“ ..
  </p>

  <p>
    ChatGPT is typing..
  </p>

  <p>
    ვაკის პარკში სეირნობას თუ მიხეილ მესხის სტადიონამდე შეჰყევით, შეამჩნევდით, რომ ტერიტორიაზე სულ 2 შენობა დგას.
    ფრანგული სკოლის მიმდებარედ, სიმწვანეში - თიბისი ლიზინგის ცენტრალური ოფისია განთავსებული, სადაც მუშაობა 09:30-წუთზე
    იწყება.
  </p>

  <p>
    თითოეულმა თანამშრომელმა კარგად იცის, რომ ამ სივრცეში პრიორიტეტული არა მხოლოდ კოლეგიალობა, საქმის ეფექტური შესრულება
    და მეტრიკებთან სწორებაა, არამედ მათი მენტალური თუ ფიზიკური ჯანმრთელობაც ზრუნვის მნიშვნელოვანი საგანია.
  </p>

  <p>
    მაგალითად, ჯანსაღი ცხოვრების წესის პოპულარიზაციისთვის „ორშაბათი-ხილის დღეა!“. 2023 წელს განხორციელებული ინიციატივის
    ფარგლებში, კორპორაციული ნუტრიციონოლოგების რჩევა გავითვალისწინეთ და სეზონური ხილით ვუმასპინძლდებით ჩვენს გუნდს.
  </p>
</div>

<div class="container-fluid m-0 p-0">
  <div class="full-color background-blue" style="background-color: #428aed; padding: 0;">
    <div class="container" style="max-width: 800px;">
      <img src="../../../../assets/blog/workspace/img1.jpg" alt="" />
    </div>
  </div>
</div>

<div class="container blog-item custom">
  <p class="quote-sign dark-blue">“</p>

  <p>
    <b style="font-size: 24px; font-family: 'TBCX-BOLD'">
      მთელი დღის მანძილზე საქმეში ჩაფლულმა შესაძლოა საერთოდ არ იფიქრო საკუთარი რაციონის ვიტამინებით გამდიდრებაზე, სწორედ
      ამიტომ, გადავწყვიტეთ აღნიშნული ჩვენს თავზე აგვეღო და ორშაბათი ხილის დღედ გამოვაცხადეთ.
    </b>
  </p>

  <p class="right-align">ეკა ჩიკვილაძე, HR ბიზნეს პარტნიორი <br /><br /></p>

  <p>
    თუმცა „ვარჯიში და სწორი კვება“ ერთმანეთის გარეშე წარმოუდგენელი, სწორედ ამიტომ, უკვე ორი წელია, რაც ჩვენი კომპანიის
    ბიჭები ფიზიკურადაც იხარჯებიან და „თიბისი ლიზინგის“ სახელით მინი-ფეხბურთის ჩემპიონატში მონაწილეობენ. ინიციატივას
    სერიოზულად მოვეკიდეთ და ყოველ კვირეულმა ვარჯიშმაც შედეგი გამოიღო, 2023 წლის სეზონი მე-10 ადგილზე დავასრულეთ.
  </p>
</div>

<div class="container-fluid m-0 p-0">
  <div class="full-color background-blue" style="background-color: #428aed; padding: 0;">
    <div class="container" style="max-width: 800px;">
      <img src="../../../../assets/blog/workspace/img2.jpg" alt="" />
    </div>
  </div>
</div>

<div class="container blog-item custom">
  <p class="quote-sign dark-blue">“</p>

  <p>
    <b style="font-size: 24px; font-family: 'TBCX-BOLD'">
      საქმე ისედაც არის ის ფუნდამენტი, რაც გვაკავშირებს, მაგრამ როცა ყოველ კვირა, არაფორმალურ გარემოში, საერთო ჰობის
      გამო იკრიბებით, ვარჯიშობთ, იხარჯებით, გუნდურ გადაწყვეტილებებს იღებთ და საერთო მიზნისკენ ისწრაფვით, ის საქმეც
      გიმარტივდება, რასაც ხანდახან რუტინულად ასრულებ. მოკლედ, ფეხბურთი მართლა მეტია ვიდრე სპორტი და არაჩვეულებრივად
      ავითარებს ურთიერთობებს
    </b>
  </p>

  <p class="right-align">ნიკუშა მესხია, კორპორაციული პროექტების მენეჯერი<br /><br /></p>

  <p>
    სპორტზე საუბრისას არც ის უნდა დავივიწყოთ, რომ განსაკუთრებით საინტერესო მატჩების ყურება თანამშრომლებს ჩვენს ოფისში,
    დიდ ეკრანზე, გემრიელი სნექების თანხლებით არაერთხელ შევთავაზეთ. ორგანიზებულმა საფეხბურთო საღამოებმა წარმატებით
    ჩაიარა, ნუ, სულ მცირე იმათთვის მაინც, ვისმა საყვარელმა გუნდმაც მოიგო.
  </p>

  <p>
    რაც არ უნდა უცნაურად ჟღერდეს, კომპანიაში ჩვენი ირინა ფრუიძის თუ დავით რაფავას ექვსეულებიც გვყავს, რადგან
    ინტელექტუალური თამაში „რა, სად, როდის?“ ჩავატარეთ და მინი, თუმცა ბროლის ბუ გამორჩეულ მოაზროვნეს, ხოლო წარმატების
    სერტიფიკატები - მთელ გუნდს გადავეცით.
  </p>

  <p>
    დღეისათვის სულ ეს იყო, თუმცა მოსაყოლი იმდენად დიდია, რომ Vol.2-ით ძალიან მალე დაგიბრუნდებით.
  </p>
</div>
</ng-container>


<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      TBC Leasing's Work Environment<br />
      <span style="font-family: TBCX-Regular;">Vol.1</span>
    </h1>
    <h6>November 2023</h6>
    <br />
  
    <p>
      “ChatGPT, show me what a work week should look like in a company where employee well-being is a priority”
    </p>
  
    <p>
      ChatGPT is typing..
    </p>
  
    <p>
      If you were to take a walk in Vake Park or head toward Mikheil Meskhi Stadium, you would notice that there are only two buildings on the premises. Adjacent to the French School, nestled in greenery, is TBC Leasing's central office, where work begins at 09:30.
    </p>
  
    <p>
      Each employee is well aware that in this space, the priority is not only collegiality, effective task completion, and alignment with metrics, but also their mental and physical health, which is a significant focus of care.
    </p>
  
    <p>
      For instance, to promote a healthy lifestyle, “Monday is Fruit Day!” As part of an initiative implemented in 2023, we have taken the advice of corporate nutritionists and offer seasonal fruits to our team.
    </p>
  </div>
  
  <div class="container-fluid m-0 p-0">
    <div class="full-color background-blue" style="background-color: #428aed; padding: 0;">
      <div class="container" style="max-width: 800px;">
        <img src="../../../../assets/blog/workspace/img1.jpg" alt="" />
      </div>
    </div>
  </div>
  
  <div class="container blog-item custom">
    <p class="quote-sign dark-blue">“</p>
  
    <p>
      <b style="font-size: 24px; font-family: 'TBCX-BOLD'">
        Throughout the day, one might get so absorbed in work that they completely forget about enriching their diet with vitamins. That’s why we decided to take this responsibility upon ourselves and declared Monday as Fruit Day. 
      </b>
    </p>
  
    <p class="right-align">Eka Chikviladze, HR Business Partner<br /><br /></p>
  
    <p>
      However, “exercise and proper nutrition” are inseparable, which is why, for the past two years, our company’s guys have been physically active, participating in the mini-football championship under the name “TBC Leasing.” We took the initiative seriously, and the weekly training sessions paid off, with the 2023 season ending in 10th place.
    </p>
  </div>
  
  <div class="container-fluid m-0 p-0">
    <div class="full-color background-blue" style="background-color: #428aed; padding: 0;">
      <div class="container" style="max-width: 800px;">
        <img src="../../../../assets/blog/workspace/img2.jpg" alt="" />
      </div>
    </div>
  </div>
  
  <div class="container blog-item custom">
    <p class="quote-sign dark-blue">“</p>
  
    <p>
      <b style="font-size: 24px; font-family: 'TBCX-BOLD'">
        Work is already the foundation that connects us, but when you gather every week in an informal setting, driven by a common hobby, train, exert yourself, make team decisions, and strive for a common goal, the work you sometimes perform routinely becomes much easier. In short, football is truly more than a sport and wonderfully develops relationships.
      </b>
    </p>
  
    <p class="right-align">Nikusha Meshia, Corporate Projects Manager<br /><br /></p>
  
    <p>
      When talking about sports, let’s not forget that we’ve also offered our employees the chance to watch especially interesting matches in our office, on a big screen, with delicious snacks. The organized football evenings have been successful, well, at least for those whose favorite teams won.
    </p>
  
    <p>
      As strange as it may sound, we also have our own Irina Fruidze and Davit Raphava in the company, as we held an intellectual game of “What, Where, when?” and awarded a mini but crystal owl to an outstanding thinker, while success certificates were presented to the whole team.
    </p>
  
    <p>
      That’s all for now, but the story is so vast that we’ll return to you very soon with Vol.2.
    </p>
  </div>
  </ng-container>